import { UnauthenticatedError } from '../utils/auth';

export class TransientError extends Error {}
export class FatalError extends Error {}
export class KnownError extends FatalError {}
export class LockTimeoutError extends FatalError {}
export class LockHolderError extends FatalError {}
export class FeatureDisabledError extends Error {}
export class AbortedError extends Error {}
export class UnsupportedOBSVersionError extends Error {}

export class CreatorIneligibilityError extends Error {}

export function shouldReportErrorToSentry(error: unknown | undefined | null) {
    if (!error) {
        // Event is does not have an exception which subclasses Error
        return true;
    }
    
    if (error instanceof TransientError) {
        // Do not send transient errors to Sentry
        return false;
    } else if (error instanceof FeatureDisabledError) {
        // Do not send "feature is disabled" errors to Sentry
        return false;
    } else if (error instanceof AbortedError) {
        // Do not send "operation aborted" errors to Sentry
        return false;
    } else if (error instanceof UnsupportedOBSVersionError) {
        // Do not send "unsupported OBS version" errors to Sentry
        return false;
    } else if (error instanceof CreatorIneligibilityError) {
        // Do not send "creator inaligible for live streaming" errors to Sentry
        return false;
    } else if (error instanceof UnauthenticatedError) {
        // Do not send "unauthenticated" errors to Sentry
        return false;
    } else if (error instanceof Error) {
        const msg = error?.message ?? '';

        const exclude = [
            'Request failed with status code', // XHR errors
            'Network Error', // XHR errors
            'Failed to fetch', // XHR errors
            'NetworkError when attempting to fetch resource', // XHR errors
            'ResizeObserver loop limit exceeded', // throws by frontend-ui when the user searches for stream categories
        ];
        
        if (exclude.find((value) => msg.includes(value))) {
            return false;
        }
    }

    return true;
  }
  